module.exports = __webpack_public_path__ + "assets/img/7c51cb3fc1f29aae0422190f306548bf.png";